import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconTrash = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconTrash.dimensions.width} ${IconTrash.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M15.429.003c1.691 0 2.833 1.161 2.837 2.875v1.38h6.954c.448 0 .737.233.77.61.04.432-.263.741-.747.744-.727.007-1.455 0-2.182 0-.079 0-.155.007-.25.014-.023.595-.046 1.174-.063 1.756-.16 5.014-.319 10.027-.483 15.04-.086 2.562-2.153 4.578-4.684 4.581H8.448c-2.573 0-4.63-1.996-4.716-4.6-.135-4.072-.257-8.144-.385-12.213-.046-1.47-.099-2.94-.148-4.411 0-.044-.007-.087-.013-.163H2.23c-.454 0-.905-.017-1.359.003-.424.02-.72-.136-.872-.542v-.33c.178-.376.467-.502.879-.499 2.182.014 4.367.007 6.55.007h.345V2.758c.003-1.38.915-2.485 2.254-2.721.191-.034.388-.034.583-.034h4.818Zm6.016 5.57H4.591v.006c0 .176-.003.336 0 .496.175 5.416.349 10.835.527 16.251.062 1.876 1.514 3.303 3.376 3.31 3.018.01 6.036.01 9.054 0a3.375 3.375 0 0 0 3.377-3.263c.105-2.635.184-5.273.273-7.912.082-2.405.168-4.807.247-7.212.017-.552 0-1.108 0-1.677ZM10.407 1.36c-.586.003-1.149.416-1.221.978-.08.622-.017 1.26-.017 1.9h7.757c0-.543.027-1.055-.006-1.564-.05-.765-.573-1.308-1.294-1.314a303.236 303.236 0 0 0-5.22 0Z" />
        <Path d="M9.656 15.52v4.896c0 .143 0 .293-.043.426a.646.646 0 0 1-.688.44.669.669 0 0 1-.602-.59c-.013-.086-.006-.18-.006-.269v-9.797c0-.08 0-.163.006-.243a.683.683 0 0 1 .678-.629.67.67 0 0 1 .655.646c.007.1.003.196.003.295v4.818l-.003.006ZM12.355 15.52v-5.034c0-.286.105-.502.355-.642.23-.13.48-.133.675.036.135.12.214.313.303.48.026.05.01.123.01.186v9.957c0 .096 0 .2-.03.293a.65.65 0 0 1-.707.482.66.66 0 0 1-.596-.619c-.007-.09-.003-.18-.003-.27v-4.87h-.007ZM16.393 15.493v-4.87c0-.134 0-.273.036-.4.08-.286.385-.482.675-.462.32.023.58.273.622.599.013.09.007.18.007.269v9.797c0 .08 0 .163-.007.243-.043.37-.332.626-.684.616a.65.65 0 0 1-.646-.652c-.013-.772-.006-1.544-.006-2.316V15.49l.003.004Z" />
      </G>
    </Svg>
  )
}

IconTrash.dimensions = {
  width: 26,
  height: 27,
}

export default IconTrash
